export const TAB_EVENT = "tabEvent";

export enum TAB_EVENTS {
    REQUEST_PAGE = "REQUEST_PAGE",
    PING_PAGE = "PING_PAGE",
    REFRESH_SALE = "REFRESH_SALE",
}

export enum AGENT_EVENTS {
    REQUEST_OPEN_PAGES = "REQUEST_OPEN_PAGES",
    PAGE_RESPONSE = "PAGE_RESPONSE",
    ENABLE_RESPONSE = "ENABLE_RESPONSE",
    DISABLE_RESPONSE = "DISABLE_RESPONSE",
    PING_TABS = "PING_TABS",
    REFRESH_SALE = "REFRESH_SALE",
}

function sendEvent(event: {
    type: AGENT_EVENTS | TAB_EVENTS;
    data?: any;
    success?: (err?: any, result?: any) => void;
}): void {
    if(typeof document !== "undefined") {
        document.dispatchEvent(new CustomEvent(TAB_EVENT, {
            detail: event,
        }));
    }
}

export function disableResponse(): void {
    sendEvent({
        type: AGENT_EVENTS.DISABLE_RESPONSE,
    });
}

export function enableResponse(): void {
    sendEvent({
        type: AGENT_EVENTS.ENABLE_RESPONSE,
    });
}

export function pingTabs(page: string, message = ""): void {
    sendEvent({
        type: AGENT_EVENTS.PING_TABS,
        data: {
            page,
            message,
        },
    });
}

export function refreshSale(): void {
    sendEvent({
        type: AGENT_EVENTS.REFRESH_SALE,
    });
}

export function getOpenPages(ignoreCurrent = true): Promise<Record<string, boolean>> {
    if(process.env.NODE_ENV === "test") {
        return Promise.resolve({});
    }

    return new Promise((res, rej) => {
        let timedOut = false;
        const timeout = setTimeout(() => {
            timedOut = true;
            rej("Getting open pages timed out");
        }, 3000);

        sendEvent({
            type: AGENT_EVENTS.REQUEST_OPEN_PAGES,
            data: {
                ignore: ignoreCurrent,
            },
            success: (err, results) => {
                if(timedOut) {
                    return;
                }

                if(timeout) {
                    clearTimeout(timeout);
                }

                // TODO: IMPLEMENT ERROR HANDLING IN TAB WORKER
                if(err) {
                    console.error("Error when getting open pages", err);
                    rej(err);
                }

                res(results);
            },
        });
    });
}
